/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import noUiSlider from 'nouislider';
import splitting from 'splitting';
import {gsap} from 'gsap';


( function( app ) {
  const COMPONENT = {
    init: function() {
      const lines = splitting( {target: '.heading__text', by: 'lines'} );
      $( lines ).each( ( index, el ) => {
        $( el.lines ).each( ( index2, words ) => {
          $( words ).add( $( words ).next() ).wrapAll( '<span class="overflow-hidden hero-banner__line">' );
        } );
      } );

      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.primary-nav' ).slideToggle();
      } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      $( document ).on( 'updateMediaQuery', ( event ) => {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );
        $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
      } );

      // quoter
      $( document ).on( 'change', '.llgq-current-page input[type="radio"]', function() {
        if ( $( '.llgq-current-page' ).find( '.llgq_section_wrapper_2 .gfield' ).length == 1 ) {
          $( '.llgq-current-page .gform_next_button' ).trigger( 'click' );
        }
      } );

      const llQuoterTool = document.querySelector( '.ll-quoter-tool' );
      const headerVisibility = document.querySelector( '.header-visibility' );
      const footerVisibility = document.querySelector( '.footer-visibility' );
      if ( llQuoterTool ) {
        $( headerVisibility ).toggleClass( 'hidden' );
        $( footerVisibility ).toggleClass( 'hidden' );
        $( 'body' ).css( 'padding-top', 0 );
      } else {
        $( headerVisibility ).removeClass( 'hidden' );
        $( footerVisibility ).removeClass( 'hidden' );
      }

      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        initSliders( $( '#gform_page_' + formId +'_' + currentPage )[0] );
      } );

      function initSliders( page ) {
        $( page ).find( '.real-slider' ).each( function( key, val ) {
          noUiSlider.create( val, {
            start: 100,
            tooltips: true,
            connect: true,
            range: {
              'min': 1,
              'max': 10000,
            },
          } );

          val.noUiSlider.on( 'update', function( values, handle ) {
            let newVal = parseInt( values[0] );

            if ( newVal < 2000 ) {
              newVal = newVal + ' lbs.';
            } else {
              newVal = ( newVal / 2000 ).toFixed( 1 ).toString().replace( '.0', '' ) + ' tons';
            }

            $( val ).find( '.noUi-handle .noUi-tooltip' ).text( newVal );

            if ( $( val ).closest( '.gfield' ).find( 'input' ).attr( 'type' ) == 'number' ) {
              $( val ).closest( '.gfield' ).find( 'input' ).val( values[0] );
            } else {
              $( val ).closest( '.gfield' ).find( 'input' ).val( values[0] );
            }
          } );
        } );
      }

      initSliders( $( '.quoter-form .gform_page:first-child' )[0] );


      // Quoter SKIP button
      $( document ).on( 'click', '.skip-btn ', function() {
        $( '.llgq-current-page select' ).prop( 'checked', false );

        // $( '.llgq-current-page .slider-value' ).find( 'input' ).val( 0 );

        $( '.llgq-quoter-next' ).trigger( 'click' );
      } );

      const pages = document.querySelectorAll( '.gform_page' );
      const skipBtn = document.querySelectorAll( '.skip-btn' );
      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        if ( pages[currentPage - 1].classList.contains( 'hide-skip' ) ) {
          $( skipBtn ).addClass( 'hidden' );
        } else {
          $( skipBtn ).removeClass( 'hidden' );
        }
      } );

      $( '.modalClose' ).click( function() {
        $.magnificPopup.close();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
